import { Order } from '@instamenu/context-checkout';
import { DateTime } from 'luxon';

export const makeCompletionMessage = (order: Order) => {
  const type = order.scheduledAt ? 'is scheduled' : 'will be ready';
  const date =
    order.scheduledAt && !DateTime.now().hasSame(order.scheduledAt, 'day')
      ? `on ${order.scheduledAt.toFormat('MMMM d')}`
      : 'today';
  const time = order.scheduledAt
    ? `at ${order.scheduledAt.toFormat('t')}`
    : order.restaurant.waitTime
      ? `in about ${order.restaurant.waitTime} minutes`
      : 'soon';
  const nextStep = 'your order is ready';

  return `Your order ${type} ${date} ${time}. We'll send you a text when ${nextStep}.`;
};
